// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2srNi","unreadBadge":"styles_unreadBadge__TYXor","modalContent":"styles_modalContent__216uZ","modal":"styles_modal__BhHk-"};